import { renderPage } from "renderPage"
import { AccountProfileShowPage } from "./Page"

renderPage({ component: AccountProfileShowPage })
